import { Heading, Paragraph, Stack } from '@customerio/pluma-components/react';

/**
 * Confirmation after the join request went out. Deliberately final: the page
 * offers no request status — a declined request is indistinguishable from a
 * pending one (the admins decide silently). No org name is shown (we don't
 * expose it).
 */
export function RequestSentStep() {
  return (
    <Stack gap="200" data-test-join-request-sent>
      <Heading level="1" size="md">
        Request sent
      </Heading>
      <Paragraph color="subtle">
        We've notified an admin. Once they approve your request, you'll receive an email to set your password and get
        started.
      </Paragraph>
      <Paragraph color="subtle">You can close this page.</Paragraph>
    </Stack>
  );
}
